module.exports = __webpack_public_path__ + "img/ico_earncoins_account_fail@3x.6f81ed23.png";